import { FC } from 'react';

import { Card, FullPageContainer, Table, useBreakpoint } from '@hh.ru/magritte-ui';

import { VacanciesTableBody } from 'components/MultiCreationAuction/VacanciesTable/VacanciesTableBody/VacanciesTableBody';
import { VacanciesTableHeader } from 'components/MultiCreationAuction/VacanciesTable/VacanciesTableHeader/VacanciesTableHeader';

export const MAX_VACANCY_SELECT = 100;

export const VacanciesTable: FC = () => {
    const { isMobile } = useBreakpoint();

    return (
        <FullPageContainer>
            {({ paddingLeft, paddingRight }) => {
                return (
                    <Card stretched>
                        {!isMobile ? (
                            <Table
                                stickyHeader
                                divider
                                dividerTop={false}
                                paddingLeft={paddingLeft}
                                paddingRight={paddingRight}
                            >
                                <VacanciesTableHeader paddingLeft={paddingLeft} paddingRight={paddingRight} />
                                <VacanciesTableBody paddingLeft={paddingLeft} paddingRight={paddingRight} />
                            </Table>
                        ) : (
                            <>
                                <VacanciesTableHeader paddingLeft={paddingLeft} paddingRight={paddingRight} />
                                <VacanciesTableBody paddingLeft={paddingLeft} paddingRight={paddingRight} />
                            </>
                        )}
                    </Card>
                );
            }}
        </FullPageContainer>
    );
};
